"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POST_TYPE = void 0;
var POST_TYPE;
(function (POST_TYPE) {
    POST_TYPE["PointsEarned"] = "POINTS_EARNED";
    POST_TYPE["AttendingEvent"] = "ATTENDING_EVENT";
    POST_TYPE["Message"] = "MESSAGE";
    POST_TYPE["Recognize"] = "RECOGNIZE";
    POST_TYPE["GameScore"] = "GAME_SCORE";
    POST_TYPE["EventCreated"] = "EVENT_CREATED";
    POST_TYPE["GroupCreated"] = "GROUP_CREATED";
})(POST_TYPE = exports.POST_TYPE || (exports.POST_TYPE = {}));
//# sourceMappingURL=Post.js.map